import CardBox from "@/src/mui-custom/card/card-box/card-box";
import CardTitleBox from "@/src/mui-custom/card/card-title-box/card-title-box";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileCertificate} from "@fortawesome/pro-duotone-svg-icons";
import CardTitleText from "@/src/mui-custom/card/card-title-text/card-title-text";
import CardTitleDivider from "@/src/mui-custom/card/card-title-divider/card-title-divider";
import CardTitleContainer from "@/src/mui-custom/card/card-title-container/card-title-container";
import CardSummaryBox from "@/src/mui-custom/card/card-summary-box/card-summary-box";
import {Box, Typography} from "@mui/material";
import CardBodyBox from "@/src/mui-custom/card/card-body-box/card-body-box";
import VerticalArticlesSlider
    from "@/src/components/journal-site/common/vertical-article-slider/vertical-article-slider";
import InPressProps from "@/src/_types/in-press-props";

const InPressArticles = (props: InPressProps) => {
    return (
        <CardBox sx={{
            display: 'flex',
            paddingX: {lg: 1.5, xs: .75},
            paddingY: '1.5rem',
            alignItems: 'flex-start',
            justifyContent: 'center',
            flexWrap: 'wrap',
            flexDirection: 'row',
            width: '100%',
        }}>

            <CardTitleContainer sx={{
                paddingLeft: '.5rem',
                marginBottom: '1.5rem',
            }}>
                <CardTitleBox>
                    <FontAwesomeIcon icon={faFileCertificate} className={'icon'}/>
                    <CardTitleText variant={"h2"} sx={{
                        lineHeight: '1',
                        marginRight: '1rem',
                        alignItems: 'flex-end',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        {props.title}
                    </CardTitleText>
                </CardTitleBox>
                <CardTitleDivider/>
                <CardSummaryBox sx={{
                    fontSize: '1.25rem',
                    paddingLeft: '.5rem',
                }}>
                    <Box>
                        <Typography
                            component={'span'}
                            className={'green'}
                        >
                            {props.articles?.length}
                        </Typography>

                        <Typography component={'span'}> {'Articles'} </Typography>
                    </Box>
                </CardSummaryBox>
            </CardTitleContainer>

            <CardBodyBox sx={{
                width: '100%',
                height: '300px',
            }}>
                <VerticalArticlesSlider
                    articles={props.articles}
                />
            </CardBodyBox>
        </CardBox>
    )
}
export default InPressArticles;
